/* src/app/components/chartjs-wrapper/chartjs-wrapper.component.css */
/*# sourceMappingURL=chartjs-wrapper.component-OUBIU5G7.css.map */
